import React from 'react';
import DebtPublishWizard from '../../components/business/debtPublish/DebtPublishWizard';

/**
 * 发布债权
 * 职责：承载债权发布向导组件 `DebtPublishWizard`，负责路由入口与页面容器。
 * 交互：具体交互在向导组件中实现，此页不包含额外状态与逻辑。
 */
const PublishDebtPage = () => {
  return (
    <div className="page-container p-debt-management-publish">
      <div className="page-content page-content-wide">
        <DebtPublishWizard />
      </div>
    </div>
  );
};

export default PublishDebtPage;
